// Canonical onboarding step identifiers and per-role flows.
// These are used both for rendering components and for validation/navigation logic
// so we never rely on raw numeric "magic" step values.

export const ROLE_TYPES = {
  CARRIER: "carrier",
};

export const STEP_IDS = {
  BASIC_INFO: "BASIC_INFO",
  AUTHORITY: "AUTHORITY",
  SUMMARY: "SUMMARY",
};

// The index in each array maps directly to currentStep from OnboardingContext.
export const ONBOARDING_FLOWS = {
  [ROLE_TYPES.CARRIER]: [STEP_IDS.BASIC_INFO, STEP_IDS.AUTHORITY, STEP_IDS.SUMMARY],
};


